<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h5 style="margin-bottom: 0px;">SOLICITUDES</h5>
            <h6 style="margin-top: 0px;">Gestión de Solicitudes Públicas en Archivo Judicial</h6>            
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
                <div class="area">
                    <Busqueda v-on:ValorDeConsulta ="ObtenDatos($event)" :barCode= this.Documento.CodigoBarras :actualiza= this.ActualizaConsulta />
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
                <div class="area">
                    <div>
                            <h6>Datos Principales</h6>
                            <hr>
                    </div>
                    <div class="row align-items-center">
                        <div class="form-group col-8" id="Area_div"> 
                            <label>Área</label>                                  
                            <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
                        </div>
                        <div class="form-group col-4" id="Materia_div"> 
                                <label>Materia</label>
                                <div v-if="Documento.Materia != null">                                 
                                    <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
                                </div>
                                <div v-else>
                                    <input type="text" class="form-control" readonly />
                                </div>
                        </div>
                    </div>
                    <div class="row align-items-center">
                            <div class="form-group col-4" id="TipoDocumento_div"> 
                                <label>Tipo de Documento</label>                                  
                                <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
                            </div>
                            <div class="form-group col-4" id="Anio_div"> 
                                <label>Año</label>
                                <input type="text" class="form-control" v-model="Documento.Anio" readonly/>
                            </div>
                            <div class="form-group col-4" id="Consecutivo_div"> 
                                <label>Consecutivo</label>                                  
                                <input type="text"  class="form-control" v-model="Documento.Consecutivo" readonly/>
                            </div>
                            
                    </div>
                    <div class="row align-items-center ">
                            <div class="form-group col-4" id="Estatus_div"> 
                                <label>Codigo</label>                                  
                                <input type="text" class="form-control" v-model="Documento.CodigoBarras" readonly/>
                            </div>
                            <div class="form-group col-4" id="Estatus_div"> 
                                <label>Estatus del Documento</label>                                  
                                <input type="text" class="form-control" v-model="Documento.TipoEstatusInventario.Nombre" readonly/>
                            </div>
                    </div>
                    <div class="row align-items-center" v-if="Documento.Anexos!=null">
                        <div class="form-group col-12" id="TipoDocumento_div">
                            <label>Observaciones y/o Anexos</label>
                            <input type="text" class="form-control" v-model="Documento.Anexos" readonly />
                        </div>
                    </div>
                    <div v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId == 1 ||Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId==2">
                        <div class="row">
                            <div class="form-group col-9">
                            <h6>Datos de las Partes</h6>
                            </div>
                        </div>
                        <div id="Partes_table" class="table-responsive-sm">
                                <table class="table table-striped table-light table-hover">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th >Parte</th>
                                            <th >Nombre</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-dark">
                                        <tr v-if="Documento.Partes.length <= 0">
                                            <td colspan="12" class="text-center">No hay registro Partes</td>
                                        </tr>
                                        <tr v-else v-for="parte in Documento.Partes" :key="parte.Documento_Referencia">
                                            <td>{{parte.Tipo_Parte}}</td>
                                            <td>{{parte.Nombre}} {{parte.ApellidoPaterno}} {{parte.ApellidoMaterno}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                        <div class="row">
                                <div class="form-group col-9">
                                <h6>Datos de Inventario</h6>
                                </div>
                        </div>
                        <div id="Volumen_table" class="table-responsive-sm">
                            <table class="table table-striped table-light table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>No.</th>
                                        <th>Fojas</th>
                                        <th>Ubicación</th>
                                        <th>Estatus</th>
                                        <th>Contenido</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="Documento.Volumenes.length <= 0">
                                        <td colspan="12" class="text-center">No hay registro del Volumen</td>
                                    </tr>
                                    <tr v-else v-for="detalle in Documento.Volumenes" :key="detalle.VolumenId">
                                        <td>{{detalle.NumVolumen}}</td>
                                        <td>{{detalle.Fojas}}</td>
                                        <td>{{detalle.Area.Nombre}}</td>
                                        <td v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                                            <span class="badge badge-pill badge-success text-center">Disponible en Archivo</span>
                                        </td>
                                        <td v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                                            <span class="badge badge-pill badge-warning text-center">En tramite por solicitud de prestamo</span>
                                        </td>
                                        <td v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                                           <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                                        </td> 
                                        <td width="400" v-html="DesglosaContenido(detalle)"></td>
                                        <td class="text-center" style="float: left;" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId != 3 ">
                                            <input type="checkbox" v-model="ListaVolumenes" v-bind:value="detalle.VolumenId" />
                                        </td>
                                        
                                        <td v-else></td>
                                    </tr>
                                </tbody>
                            </table>
                            
                        </div>
                        <div v-if="Documento.Incidentes.length>0">
                            <h6>INCIDENTES DEL DOCUMENTO</h6>
                            
                        </div>
                        <div id="Incidentes_table" class="table-responsive-sm" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Incidentes.length>0">
                            <table class="table table-striped table-light table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                    <th>No.</th>
                                    <th>Tipo Incidente</th>
                                    <th>Ubicacion</th>
                                    <th>Estatus</th>
                                    <th></th>
                                    <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="Documento.Incidentes.length <= 0">
                                    <td colspan="12" class="text-center">No hay registro de Incidentes</td>
                                    </tr>
                                    <tr v-else v-for="detalle in Documento.Incidentes" :key="detalle.IncidenteId">
                                    <td width="50">{{detalle.NumeroIncidente}}</td>
                                    <td width="200">{{detalle.TipoIncidente}}</td>
                                    <td width="300" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                                    <td width="300" v-else>{{detalle.Area.Nombre}}</td>
                                    <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                                        <span class="badge badge-pill badge-success text-center">Disponible en Archivo</span>
                                    </td>
                                    <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                                        <span class="badge badge-pill badge-warning text-center">En tramite por solicitud de prestamo</span>
                                    </td>
                                    <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                                        <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                                    </td>
                                    <td width="400"></td>
                                    <td width="50" class="category_enabled" style="float: left;" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId != 3">
                                        <input type="checkbox" v-model="ListaIncidentes" v-bind:value="detalle.IncidenteId"/>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="Documento.Tercerias.length>0">
                            <h6>TERCERIAS DEL DOCUMENTO</h6>
                            
                        </div>
                        <div id="Tercerias_table" class="table-responsive-sm" v-if="Documento.TipoEstatusInventario.TipoEstatusInventarioDocumentoId != 4 && Documento.Tercerias.length>0">
                            <table class="table table-striped table-light table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                    <th>No.</th>
                                    <th>Tipo Terceria</th>
                                    <th>Ubicacion</th>
                                    <th>Estatus</th>
                                    <th></th>
                                    <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="Documento.Tercerias.length <= 0">
                                    <td colspan="12" class="text-center">No hay registro de Tercerias</td>
                                    </tr>
                                    <tr v-else v-for="detalle in Documento.Tercerias" :key="detalle.TerceriaId">
                                    <td width="50">{{detalle.NumeroTerceria}}</td>
                                    <td width="200">{{detalle.TipoTipo}}</td>
                                    <td width="300" v-if="detalle.Area.AreaId ==21">{{detalle.Area.Nombre}} - {{Documento.SedeArchivo.Nombre}}</td>
                                    <td width="300" v-else>{{detalle.Area.Nombre}}</td>
                                    <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 1">
                                        <span class="badge badge-pill badge-success text-center">Disponible en Archivo</span>
                                    </td>
                                    <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 2">
                                        <span class="badge badge-pill badge-warning text-center">En tramite por solicitud de prestamo</span>
                                    </td>
                                    <td width="200" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId == 3">
                                        <span class="badge badge-pill badge-danger text-center">{{detalle.EstatusVolumenes.Nombre}}</span>
                                    </td>
                                    <td width="400"></td>
                                    <td width="50" class="category_enabled" style="float: left;" v-if="detalle.EstatusVolumenes.TipoEstatusVolumenId != 3">
                                        <input type="checkbox" v-model="ListaTercerias" v-bind:value="detalle.TerceriaId"/>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                        <div id="BotonBusqueda_div" class="text-right" v-if="this.ShowBotonCheck == true">
                                <button class="btn btn-sm btn-dark"  @click='SolicitarDocumento(Documento.InventarioDocumentoId, Documento.Area)'>Aceptar</button>
                            </div>

                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="this.VisibleModalPublico==true">
            <modalPublico :inventarioDocumentoId= this.volIdModal :volumenSolicitud= this.VolumenesModal :incidenteSolicitud= this.IncidentesModal :terceriaSolicitud= this.TerceriasModal :AreaDatos= this.areaModal @dialogo='EstatusModalPublico($event)'></modalPublico>
        </div>
        
    </div>
    
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import FiltroDeBusqueda from '@/components/ArchivoJudicial/Comun/ConsultaDocumento.vue'
import ModalCapturaPublico from '@/components/ArchivoJudicial/Comun/DatosPublico.vue'

export default {
    
    components : {
        Busqueda: FiltroDeBusqueda,
        modalPublico: ModalCapturaPublico
    },
    data(){
        return{
            Documento: {
                InventarioDocumentoId: "",
                Area: {
                    AreaId:0,
                    Nombre:""
                },
                Materia: {
                    MateriaId: 0,
                    Nombre: ""
                },
                TipoDocumento: {
                    TipoDocumentoId: 0,
                    Nombre: ""
                },
                Año: "",
                Consecutivo: "",
                CodigoBarras: "",
                Fecha_Registro: null,
                TipoEstatusInventario: {
                    TipoEstatusInventarioDocumentoId: 0,
                    Nombre: ""
                },
                Volumenes :[],
                Partes: []
            },
            VisibleModalPublico: {
             type: Boolean,
             default: false
            },
            volIdModal: [],
            areaModal: {
                AreaId: 0,
                Nombre: ""
            },
            ActualizaConsulta:{
                type: Boolean,
                default: false,
            },
            AreaArchivo: {
                type: Boolean,
                default: false
            },
            volumenesJuzgado :[],
            Etiqueta: "",
            ListaVolumenes: [],
            ListaIncidentes:[],
            ListaTercerias: [],
            VolumenesModal: [],
            IncidentesModal:[],
            TerceriasModal:[],
            SeleccionarTodos:false,
            ShowBotonCheck: false
            
        }
    },
    methods: {
        obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY <br /> h:mm a");
        },
        ObtenDatos(datos){
            this.Documento = datos.DocumentoConsulta;
            this.VerificarVolumenes(enumeraciones.areasArchivo.General);
            
        },
        SolicitarDocumento: function(valor, areaParam){
            this.VolumenesModal = this.SeleccionarVolumenes();
            this.IncidentesModal = this.SeleccionarIncidentes();
            this.TerceriasModal = this.SeleccionarTercerias();
            if(this.VolumenesModal.length>0 || this.IncidentesModal.length>0 || this.TerceriasModal.length>0)
            {
                this.AreaArchivo = true;
                this.volIdModal = valor;
                this.areaModal = areaParam;
                this.VisibleModalPublico = true;
                this.ActualizaConsulta = false;
                this.ListaVolumenes = [];
                this.ListaIncidentes = [];
                this.ListaTercerias = [];
            }
            else{
                comun.mensajeDeAlerta("Seleccione los Volumenes deseados en la Solicitud", null, null);
            }
        },
        
        EstatusModalPublico(valor){
            this.VisibleModalPublico = valor;
            if(valor == true)
            {
                this.ActualizaConsulta = false;
            }
            else
            {
                this.ActualizaConsulta = true;
            };
        },
        SeleccionarVolumenes(){
            let VolumenesEnSolicitud = [];
            this.ListaVolumenes.forEach((element) =>{
                let AgregaVol = this.volumenesJuzgado.find(vol =>vol.VolumenId == element);
                VolumenesEnSolicitud.push(
                    AgregaVol)
            });
            return VolumenesEnSolicitud;
        },
        SeleccionarIncidentes(){
            let IncidentesEnSolicitud = [];
            this.ListaIncidentes.forEach((element) =>{
                let AgregaIncidente = this.Documento.Incidentes.find(incidente =>incidente.IncidenteId == element);
                IncidentesEnSolicitud.push(
                    AgregaIncidente.IncidenteId)
            });
            return IncidentesEnSolicitud;
        },
        SeleccionarTercerias(){
            let TerceriasEnSolicitud = [];
            this.ListaTercerias.forEach((element) =>{
                let AgregaTerceria = this.Documento.Tercerias.find(terceria =>terceria.TerceriaId == element);
                TerceriasEnSolicitud.push(
                    AgregaTerceria.TerceriaId)
            });
            return TerceriasEnSolicitud;
        },
        SelectAll(){
            this.ListaVolumenes = [];
            if(this.SeleccionarTodos == false)
            {
                for (let i in this.volumenesJuzgado)
                {
                    this.ListaVolumenes.push(this.volumenesJuzgado[i].VolumenId)
                }
            };
        },
        VerificarVolumenes(areaId){
            console.log(areaId)
            var volumenesEnJuzgado = [];
            this.VolumenesModal = [];
            this.ListaVolumenes = [];
            volumenesEnJuzgado = this.Documento.Volumenes.filter(e=> (e.EstatusVolumenes.TipoEstatusVolumenId == 1 || e.EstatusVolumenes.TipoEstatusVolumenId == 2) &&  e.Area.AreaId == 21)
            switch (volumenesEnJuzgado.length)
            {
                case 0:
                    this.ShowBotonCheck = false;
                    this.ShowBotonSolicitar = false;
                    break;
                default:
                    this.volumenesJuzgado = volumenesEnJuzgado;
                    this.ShowBotonCheck = true;
                    this.ShowBotonSolicitar = true;
                    break;    
            }
        },
        DesglosaContenido: function (datos){
            let Contenido ="";
            // if(datos.AnexosVolumen!=null && datos.AnexosVolumen.length>0)
            // {
            //     Contenido= Contenido +"<b class='text-primary'>ANEXOS</b><br/>";
            //         $.each(datos.AnexosVolumen, function(index, enVolumen)
            //         {
            //         Contenido = Contenido + "Cantidad: "+ enVolumen.Cantidad + ",  Observaciones: " + enVolumen.Observaciones + "<br/>";
            //         })
            // };
            if(datos.Amparos!=null && datos.Amparos.length>0)
            {
              Contenido= Contenido +"<b class='text-primary'>AMPAROS</b><br/>";
                    $.each(datos.Amparos, function(index, enVolumen)
                    {
                    Contenido = Contenido + "Consecutivo: "+ enVolumen.AmparosDelDocumento.Consecutivo + "/" + enVolumen.AmparosDelDocumento.Anio + "<br/>";
                    })
            };
            if(datos.IncidenteVolumen!=null && datos.IncidenteVolumen.length>0)
                {
                  Contenido = Contenido +"<b class='text-primary'>INCIDENTES</b><br/>";
                    $.each(datos.IncidenteVolumen, function(index, enVolumen)
                    {
                    Contenido = Contenido + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                    })
                }
            return Contenido;
        }
    }
}
</script>

<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }

input[type="text"]:read-only:focus {
      color: #fff;
    }
#modalSolicitud{
    overflow-y:auto;
    max-height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Solicitudes/NuevaSolicitudPublicaArchivo.vue